import { useState } from "react"
import { Variables, FilterVehiclesResponse } from "../../../../../../api/vehicles/filter"
import { AddedFleetEntry } from "../../../../../../api/fleet"
import { fieldHasAllPrerequisiteValues } from "../../utils"
import { DropdownFieldComponent } from "../fields/DropdownFieldComponent"
import { DropdownFieldComponentWithDataLoad } from "../fields/DropdownFieldComponentWithDataLoad"

export type GeneratorOpts = {
  name: keyof AddedFleetEntry
  entry: AddedFleetEntry
  prerequisiteFields: (keyof Variables)[]
  dataKey: keyof FilterVehiclesResponse
  dataTestId?: string
  onChange: (value: string, fieldName: string) => void
}

export const generateManuallyResolveFleetEntryDropdown = (opts: GeneratorOpts) => {
  const { name, entry, prerequisiteFields, dataTestId, dataKey, onChange } = opts
  const value = entry[name] ? (entry[name] || ``).toString() : null
  return function () {
    const [isOpen, setIsOpen] = useState(false)
    const hasAllFields = fieldHasAllPrerequisiteValues(entry, prerequisiteFields)
    const onValueChange = (selectedValue: string) => {
      onChange(selectedValue, name)
    }
    if (!hasAllFields || (value !== null && !isOpen))
      return (
        <DropdownFieldComponent
          dataTestId={dataTestId}
          disabled={!hasAllFields}
          dropdownValues={[]}
          setIsOpen={setIsOpen}
          value={value}
          onChange={() => {}}
          onInputValueChange={() => {}}
        />
      )

    return (
      <DropdownFieldComponentWithDataLoad
        dataTestId={dataTestId}
        entry={entry}
        prerequisiteFields={prerequisiteFields}
        dataKey={dataKey}
        setIsOpen={setIsOpen}
        value={value}
        onChange={onValueChange}
      />
    )
  }
}
